export const SPRITE_WIDTH = 25;
export const SPRITE_HEIGHT = 35;
export const MAP_BOUNDARY_HEIGHT = (SPRITE_HEIGHT * 12)-SPRITE_HEIGHT;
export const MAP_BOUNDARY_WIDTH = (SPRITE_WIDTH * 32)-SPRITE_WIDTH;
export const MAP_TRUE_WIDTH = SPRITE_WIDTH * 32
export const MAP_TRUE_HEIGHT = SPRITE_HEIGHT * 12

